import { skipToken, useQuery } from "@tanstack/react-query";
import { getSsoAuthorizationRequestsPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const SSO_AUTHORIZATION_REQUEST_QUERY_KEY = "SSO_AUTHORIZATION_REQUEST";

export const ssoAuthorizationRequestKeys = {
  all: [SSO_AUTHORIZATION_REQUEST_QUERY_KEY],
  detail: (publicID: string) => [...ssoAuthorizationRequestKeys.all, publicID],
};

// A parked request is answered once; a 4xx (expired, not pending, not yours) will not change on a retry.
export const useSsoAuthorizationRequestQuery = (publicID: string | null) =>
  useQuery({
    queryKey: ssoAuthorizationRequestKeys.detail(publicID ?? ""),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getSsoAuthorizationRequestsPublicID(publicID),
        )
      : skipToken,
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
